import { useOutletContext } from 'react-router-dom';

export type RespondentType = 'student' | 'staff' | 'parent';

export interface AdminContext {
  respondentType: RespondentType;
}

export function useAdminContext(): AdminContext {
  return useOutletContext<AdminContext>();
}
